/* ==========================================================================
   Pferdegold – Announcement Bar (USP-Leiste)
   Permanente Implementierung des ABlyft-Tests pg-0006.

   Aufgaben dieses Scripts (kein DOM-Aufbau, das Markup kommt aus Liquid):
     1. Mobile-Slider: Autoplay, Pfeiltasten, Endlos-Umlauf
     2. Info-Popup: öffnen, schliessen, positionieren
     3. optionales dataLayer-Tracking

   Slider arbeitet mit scroll-snap statt translateX. Vorteil: Wischen auf
   Mobile funktioniert nativ und Desktop braucht keine Sonderbehandlung,
   dort ist der Track schlicht nicht scrollbar.
   ========================================================================== */

(function () {
  'use strict';

  var READY_FLAG = 'pgUspReady';
  var DEFAULT_INTERVAL = 3500;

  var REVIEWS_TIMEOUT_MS = 10000;

  function pushEvent(name) {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
    window.dataLayer.push({ event: 'pg_usp_bar', pg_usp_action: name });
  }

  /* ------------------------------------------------- Reviews.io Rating Bar

     Das Widget-Script wird nur geladen, wenn tatsächlich ein Container im
     DOM ist, und nur einmal pro Seite. Solange das Widget nicht fertig ist,
     bleiben die statischen Werte aus dem Theme-Editor stehen.
     -------------------------------------------------------------------- */

  function loadReviewsScript(src) {
    if (!src) return;
    if (document.querySelector('script[data-pg-usp-reviews-script]')) return;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.setAttribute('data-pg-usp-reviews-script', '');
    document.head.appendChild(s);
  }

  function watchReviewsWidget(root) {
    var live = root.querySelector('[data-pg-usp-reviews-live]');
    if (!live) return;

    var item = live.closest('[data-pg-usp-item]');
    if (!item) return;

    function isLoaded() {
      return !!live.querySelector('.RatingBarWidget.R-isLoaded');
    }

    function reveal() {
      item.classList.add('is-reviews-live');
      pushEvent('reviews_widget_loaded');
    }

    if (isLoaded()) {
      reveal();
      return;
    }

    if (typeof MutationObserver !== 'function') return;

    var observer = new MutationObserver(function () {
      if (!isLoaded()) return;
      observer.disconnect();
      reveal();
    });
    observer.observe(live, { childList: true, subtree: true });

    // Falls das Widget blockiert wird oder ausfällt: beobachten beenden,
    // der statische Fallback bleibt sichtbar.
    setTimeout(function () {
      observer.disconnect();
    }, REVIEWS_TIMEOUT_MS);

    loadReviewsScript(root.getAttribute('data-reviews-script'));
  }

  function init(root) {
    if (!root || root.dataset[READY_FLAG] === '1') return;
    root.dataset[READY_FLAG] = '1';

    var track = root.querySelector('[data-pg-usp-track]');
    var items = root.querySelectorAll('[data-pg-usp-item]');
    var prev = root.querySelector('[data-pg-usp-prev]');
    var next = root.querySelector('[data-pg-usp-next]');
    var overlay = root.querySelector('[data-pg-usp-overlay]');

    // Popups werden über ihren Namen verknüpft: ein Trigger mit
    // data-pg-usp-popup-trigger="x" gehört zum Popup data-pg-usp-popup="x".
    var triggers = root.querySelectorAll('[data-pg-usp-popup-trigger]');
    var openPopupEl = null;

    if (!track || items.length === 0) return;

    var interval = parseInt(root.getAttribute('data-interval'), 10) || DEFAULT_INTERVAL;
    var autoplayEnabled = root.getAttribute('data-autoplay') !== 'false';
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    /* ------------------------------------------------------------ Slider */

    // Der Track ist nur im Mobile-Layout scrollbar. Desktop braucht keinen
    // Slider, also laeuft dort weder Autoplay noch Umlauf.
    function isSlider() {
      return track.scrollWidth > track.clientWidth + 1;
    }

    function currentIndex() {
      var w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }

    function goTo(n) {
      if (!isSlider()) return;
      var total = items.length;
      var i = ((n % total) + total) % total;
      var left = i * track.clientWidth;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left;
      }
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || reduceMotion || !isSlider()) return;
      timer = setInterval(function () {
        // Bei geoeffnetem Popup nicht weiterblaettern, sonst wandert der
        // ausloesende Button unter dem Popup weg.
        if (openPopupEl) return;
        if (document.hidden) return;
        goTo(currentIndex() + 1);
      }, interval);
    }

    function step(delta, label) {
      goTo(currentIndex() + delta);
      startAutoplay();
      pushEvent(label);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        step(-1, 'slider_prev');
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        step(1, 'slider_next');
      });
    }

    // Nach manuellem Wischen den Timer neu starten
    var scrollDebounce = null;
    track.addEventListener(
      'scroll',
      function () {
        if (scrollDebounce) clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(startAutoplay, 400);
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    /* ------------------------------------------------------------- Popups

       Ein Trigger und ein Popup gehören über denselben Namen zusammen.
       Es ist immer höchstens ein Popup offen.
       -------------------------------------------------------------------- */

    function popupFor(trigger) {
      var name = trigger.getAttribute('data-pg-usp-popup-trigger');
      return root.querySelector('[data-pg-usp-popup="' + name + '"]');
    }

    // Popup unter dem Trigger zentrieren und im sichtbaren Bereich halten.
    // Der Caret zeigt dabei weiter auf die Mitte des Triggers.
    function positionPopup(popup, trigger) {
      if (!popup || !trigger) return;
      var caret = popup.querySelector('[data-pg-usp-caret]');
      var barRect = root.getBoundingClientRect();
      var btnRect = trigger.getBoundingClientRect();
      var center = btnRect.left - barRect.left + btnRect.width / 2;
      var width = popup.offsetWidth;
      var pad = 16;
      var max = barRect.width - width - pad;
      var left = center - width / 2;

      if (max < pad) {
        left = pad; // Leiste schmaler als das Popup
      } else {
        left = Math.max(pad, Math.min(left, max));
      }

      popup.style.left = left + 'px';
      popup.style.transform = 'none';

      if (caret) {
        // Der Caret muss innerhalb des Popups bleiben. Wenn das Popup an den
        // Rand geclampt wurde (oder der Trigger im geclippten Slider-Track
        // ausserhalb des sichtbaren Bereichs liegt), zeigt center - left sonst
        // weit neben das Popup, was das Dokument verbreitert und auf Mobile
        // horizontales Scrollen ausloest.
        var caretInset = 12;
        var caretMax = Math.max(caretInset, width - caretInset);
        caret.style.left =
          Math.max(caretInset, Math.min(center - left, caretMax)) + 'px';
      }
    }

    function closePopup() {
      if (!openPopupEl) return;
      openPopupEl.classList.remove('is-open');
      openPopupEl = null;
      if (overlay) overlay.hidden = true;
      for (var i = 0; i < triggers.length; i++) {
        triggers[i].setAttribute('aria-expanded', 'false');
      }
      startAutoplay();
    }

    function openPopup(trigger) {
      var popup = popupFor(trigger);
      if (!popup) return;
      closePopup();

      popup.classList.add('is-open');
      openPopupEl = popup;
      if (overlay) overlay.hidden = false;
      positionPopup(popup, trigger);
      stopAutoplay();

      // Bewusst als letztes: closePopup weiter oben setzt alle Trigger auf
      // false zurück, und beim Wechsel zwischen zwei Popups darf das den
      // gerade geöffneten Trigger nicht wieder überschreiben.
      trigger.setAttribute('aria-expanded', 'true');
      pushEvent(trigger.getAttribute('data-pg-usp-popup-trigger') + '_open');
    }

    for (var t = 0; t < triggers.length; t++) {
      (function (trigger) {
        var popup = popupFor(trigger);
        if (!popup) return;

        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (popup.classList.contains('is-open')) closePopup();
          else openPopup(trigger);
        });

        popup.addEventListener('click', function (e) {
          e.stopPropagation();
        });

        window.addEventListener('resize', function () {
          if (openPopupEl === popup) positionPopup(popup, trigger);
        });
      })(triggers[t]);
    }

    if (triggers.length) {
      document.addEventListener('click', closePopup);
      if (overlay) overlay.addEventListener('click', closePopup);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') closePopup();
      });
    }

    /* --------------------------------------------------------------- Start */

    watchReviewsWidget(root);
    startAutoplay();

    // Muss zum Desktop-Breakpoint in pg-usp-bar.css passen
    var mq = window.matchMedia('(min-width: 1250px)');
    var onBreakpoint = function () {
      closePopup();
      stopAutoplay();
      track.scrollLeft = 0;
      startAutoplay();
    };
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onBreakpoint);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onBreakpoint);
    }
  }

  function initAll(scope) {
    var container = scope || document;
    var bars = container.querySelectorAll('[data-pg-usp-bar]');
    for (var i = 0; i < bars.length; i++) init(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme-Editor: Section wird nach dem Speichern neu gerendert
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();